import { removeConditionalComponentsFromChildren } from '../../resources/js/components/EnhancedMarkdown/helpers/removeConditionalComponents';

function flattenChildren(children, game) {
  removeConditionalComponentsFromChildren(children, game);

  const allChildren = [];

  const pushComponentChildrenToArray = (children) => {
    if (!Array.isArray(children)) {
      children = [children];
    }

    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      allChildren.push(child);

      if (child?.props?.children) {
        pushComponentChildrenToArray(child.props.children);
      }
    }
  };

  pushComponentChildrenToArray(children);

  return allChildren;
}

export default flattenChildren;
